import { t } from '@/lib/i18n';
import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@ant-design/pro-components';
import { requireCanManageUsers } from '@/features/auth/session/guards';
import { ServiceMonitor } from '@/features/monitor/service/page';
import { useDocumentTitle } from '@/hooks/use-document-title';

export const Route = createFileRoute('/_authenticated/system/monitor/service')({
  /** Monitoring remains administrator-only, matching the API's authorization boundary. */
  beforeLoad: async ({ context, location }) => {
    await requireCanManageUsers(context.queryClient, location.href);
  },
  component: ServicePage,
});

/** Read-only snapshot of the API host and current process. */
function ServicePage() {
  useDocumentTitle(t('服务监控'));
  return (
    <PageContainer
      header={{ title: t('服务监控') }}
      content={t('查看当前 API 实例的运行时间、CPU 信息与内存状态')}
    >
      <ServiceMonitor />
    </PageContainer>
  );
}
